<template>
  <div class="personal-info">
    <b-button v-b-modal.modal-prevent-closing variant="outline-dark"
      >Створити клієнта
      <b-icon icon="file-person"></b-icon>
    </b-button>
    <br /><br />
    <b-modal
      id="modal-prevent-closing"
      ref="modal"
      title="Створення клієнта"
      @show="resetModal"
      @hidden="resetModal"
      @ok="handleOk"
      centered
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group
          label="Ім'я"
          label-for="name-input"
          invalid-feedback="Додайте ім'я"
          :state="nameState"
        >
          <b-form-input
            id="surname-input"
            v-model="client.client_name"
            :state="nameState"
            required
            @blur="$v.client.client_name.$touch()"
            :class="{
              'is-invalid':
                $v.client.client_name.$error && $v.client.client_name.$dirty,
            }"
          ></b-form-input>
        </b-form-group>
        <b-form-group
          label="Призвіще"
          label-for="surname-input"
          invalid-feedback="Додайте призвіще"
          :state="nameState"
        >
          <b-form-input
            id="name-input"
            v-model="client.client_surname"
            :state="nameState"
            required
            :class="{
              'is-invalid':
                $v.client.client_surname.$error &&
                $v.client.client_surname.$dirty,
            }"
            @blur="$v.client.client_surname.$touch()"
          ></b-form-input>
        </b-form-group>
        <b-form-group
          label="Номер телефону"
          label-for="phonenum-input"
          invalid-feedback="Додайте номер телефону"
          :state="nameState"
        >
          <b-form-input
            id="phonenum-input"
            v-model="client.client_phonenum"
            type="number"
            :state="nameState"
            required
            :class="{
              'is-invalid':
                $v.client.client_phonenum.$error &&
                $v.client.client_phonenum.$dirty,
            }"
            @blur="$v.client.client_phonenum.$touch()"
          ></b-form-input>
        </b-form-group>
        <b-form-group
          label="Номер карти"
          label-for="cardnum-input"
          invalid-feedback="Додайте номер карти"
          :state="nameState"
        >
          <b-form-input
            id="cardnum-input"
            v-model="client.client_cardnum"
            type="number"
            :state="nameState"
            required
            :class="{
              'is-invalid':
                $v.client.client_cardnum.$error &&
                $v.client.client_cardnum.$dirty,
            }"
            @blur="$v.client.client_cardnum.$touch()"
          ></b-form-input>
        </b-form-group>
        <b-form-group
          label="Дата народження"
          label-for="birthday-input"
          invalid-feedback="Додайте дату народження"
          :state="nameState"
        >
          <b-input-group>
            <date-range-picker
              :showDropdowns="true"
              :singleDatePicker="true"
              opens="center"
              :autoApply="true"
              ref="picker"
              v-model="datePickerSettings.dateRange"
              :locale-data="datePickerSettings.locale"
              :max-date="datePickerSettings.maxDate"
            ></date-range-picker>
            <!--          <b-form-input-->
            <!--              id="example-input"-->
            <!--              v-model="client.client_birthday"-->
            <!--              type="text"-->
            <!--              placeholder="ГГГГ-ММ-ДД"-->
            <!--              autocomplete="off"-->
            <!--              :class="{'is-invalid': $v.client.client_birthday.$error&&$v.client.client_birthday.$dirty}"-->
            <!--              @blur="$v.client.client_birthday.$touch()"-->
            <!--             ></b-form-input>-->
            <!--          <b-input-group-append>-->
            <!--            <b-form-datepicker-->
            <!--            :initial-date="'1990-5-1'"-->
            <!--            :show-decade-nav="true"-->
            <!--            :hide-header="true"-->
            <!--            :locale="'ru'"-->
            <!--            id="birthday-input"-->
            <!--            v-model="client.client_birthday"-->
            <!--            :class="{'is-invalid': $v.client.client_birthday.$error&&$v.client.client_birthday.$dirty}"-->
            <!--            @blur="$v.client.client_birthday.$touch()"-->
            <!--            class="mb-2">-->

            <!--            </b-form-datepicker>-->
            <!--          </b-input-group-append>-->
          </b-input-group>
        </b-form-group>
        <b-form-group
          label="Стать"
          label-for="gender-input"
          invalid-feedback="Додайте стать"
          :state="nameState"
        >
          <b-form-select
            id="gender-input"
            v-model="client.client_gender"
            :options="options"
            :class="{
              'is-invalid':
                $v.client.client_gender.$error &&
                $v.client.client_gender.$dirty,
            }"
            @blur="$v.client.client_gender.$touch()"
          >
            <template #first>
              <b-form-select-option :value="null" disabled
                >Оберіть стать</b-form-select-option
              >
            </template>
          </b-form-select>
        </b-form-group>
      </form>
    </b-modal>
    <Alert
      :class="this.class"
      v-bind:text="this.AlertText"
      v-bind:activErr="this.activErr"
    ></Alert>
  </div>
</template>

<script>
import moment from "moment";
import Alert from "@/components/Toasts/Alert";
import { mapActions } from "vuex";
import { required } from "vuelidate/lib/validators";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

export default {
  name: "ClientCreator",
  components: {
    DateRangePicker,
    Alert,
  },
  data: function () {
    return {
      client: {
        client_name: null,
        client_surname: null,
        client_phonenum: null,
        client_birthday: null,
        client_cardnum: null,
        client_gender: null,
      },
      class: "",
      AlertText: "",
      activErr: "",
      nameState: null,
      options: [
        { value: "Чоловічий", text: "Чоловічий" },
        { value: "Жіночий", text: "Жіночий" },
      ],
      datePickerSettings: {
        dateRange: {
          startDate: "",
        },
        maxDate: "",
        locale: {
          direction: "ltr",
          format: "dd.mm.yyyy",
          applyLabel: "",
          cancelLabel: "",
          weekLabel: "W",
          customRangeLabel: "Custom Range",
          daysOfWeek: ["Нд", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
          monthNames: [
            "січень",
            "лютий",
            "березень",
            "квітень",
            "травень",
            "червень",
            "липень",
            "серпень",
            "вересень",
            "жовтень",
            "листопад",
            "грудень",
          ],
          firstDay: 1,
        },
      },
    };
  },
  validations: {
    client: {
      client_name: {
        required,
      },
      client_surname: {
        required,
      },
      client_phonenum: {
        required,
      },
      client_cardnum: {
        required,
      },
      client_gender: {
        required,
      },
    },
  },
  mounted() {
    this.datePickerSettings.dateRange.startDate = 633111355;
  },
  methods: {
    ...mapActions(["createClient"]),
    resetModal() {
      this.client = {
        client_gender: null,
        client_name: null,
        client_cardnum: null,
        client_birthday: null,
        client_phonenum: null,
        client_surname: null,
      };
      this.$v.client.$reset();
    },
    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.handleSubmit();
    },
    showModalCreate(text, color) {
      this.activErr = true;
      this.class = color;
      this.AlertText = text;
      setTimeout(() => {
        this.activErr = false;
      }, 4000);
    },
    async handleSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        console.log("invalid");
        return;
      }
      let client = this.client;
      client.client_birthday = moment(
        this.datePickerSettings.dateRange.startDate,
      ).format("YYYY-MM-DD");
      let newClient = await this.createClient({ client });
      if (newClient === "Exists") {
        this.showModalCreate("Клієнт з таким номером карти вже існує!", "red");
        return;
      }
      this.$emit("newClient", newClient.id);
      // this.$emit('refresh-list')

      this.$nextTick(() => {
        this.$bvModal.hide("modal-prevent-closing");
      });
    },
  },
};
</script>

<style lang="scss"></style>
